<template>
  <div class="copyright">
    <a-layout style="padding: 24px 0; background: #fff">
      <!-- <a-layout-sider width="200" style="background: #fff">
        <a-menu
          mode="inline"
          v-model="current"
          :default-selected-keys="['recyclePicture']"
          style="height: 100%"
        >
          <a-menu-item key="recyclePicture" @click="linkTo('recyclePicture')">
            图片素材
          </a-menu-item>
          <a-menu-item key="recycleCopywriting" @click="linkTo('recycleCopywriting')">
            文案素材
          </a-menu-item>
          <a-menu-item key="recycleH5" @click="linkTo('recycleH5')">
            H5链接
          </a-menu-item>
          <a-menu-item key="recycleFont" @click="linkTo('recycleFont')">
            字体版权
          </a-menu-item>
          <a-menu-item key="recycle3D" @click="linkTo('recycle3D')">
            3D素材版权
          </a-menu-item>
        </a-menu>
      </a-layout-sider> -->
      <a-layout-content :style="{ padding: '0 24px', minHeight: '280px' }">
        <router-view :companyId="companyId"></router-view>
      </a-layout-content>
    </a-layout>
  </div>
</template>

<script>
export default {
  props: ['companyId'],
  data() {
    return {
      current: ['recyclePicture']
    }
  },
  created() {
    this.$set(this.current, 0, this.$route.matched[2].name)
  },
  methods: {
    linkTo(name) {
      this.$router.push({ name: name })
    }
  }
}
</script>

<style scoped>
.copyright {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}
</style>